/**
 * @file: SettlementFormStatus.ts
 * @author: eric <xuxiang@zhichetech.com>
 * @copyright: (c) 2019-2020 sichuan zhichetech co., ltd.
 */

export enum SettlementFormStatus {
  Draft = 'draft',
  Confirmed = 'confirmed',
  Canceled = 'canceled',
}

export const SettlementFormStatusValueSet = new Set([
  SettlementFormStatus.Draft,
  SettlementFormStatus.Confirmed,
  SettlementFormStatus.Canceled,
]);
